import { combineDucks } from "lib/utils/duck";

import CalendarView from "./CalendarView";
import ShowSlotModal from "./ShowSlotModal";

export default combineDucks({
  CalendarView,
  ShowSlotModal,
});



// WEBPACK FOOTER //
// ./src/modules/calendar/index.js